import { defBreadcrumb } from "../../data/DataBreadcrumb";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import ContentContainer from '../ContentContainer/ContentContainer';
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import { BlogBanner } from "../../components/BlogPost/BlogBanner";
import { BlogTitle } from "../../components/BlogPost/BlogTitle";
import { SocialMediaShareBar } from "../../components/SocialMedia/SocialMediaShareBar";
import { BlogWysiwyg } from "../../components/BlogPost/BlogWysiwyg";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";

type breadcrumbProps = {
  pageTitle: string;
  asPath: string;
};
export const breadcrumb = ({ pageTitle, asPath }: breadcrumbProps) => {
  return [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + "/tentang-perusahaan",
        name: "Tentang Perusahaan"
      }
    },
    {
      "@type": "ListItem",
      position: "3",
      item: {
        "@id": process.env.baseURL + asPath,
        name: pageTitle
      }
    }
  ];
};

type contentProps = {
  items: any;
  heading: string;
  subSlug: string;
  data: any;
};
export const Content = ({ items, heading, subSlug, data }: contentProps) => {
  return (
    <>
      <BreadcrumbComponent items={items} />
      <HeadingComponent headingText={heading}></HeadingComponent>
      <ContentContainer subSlug={subSlug} data={data}></ContentContainer>
    </>
  );
};

type PageSlugProps = {
  data: any;
  asPath: string;
  breadcrumb: any;
  description: string;
  itemsForBreadCrumb: any;
  winSize: any;
};
export const PageSlug = ({
  data,
  asPath,
  breadcrumb,
  description,
  itemsForBreadCrumb,
  winSize
}: PageSlugProps) => {
  return (
    <Layout>
      <NextHead
        title={data && data.title}
        description={description}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={itemsForBreadCrumb} />
      <BlogBanner img={data.banner} alt={data.title} />
      <BlogTitle title={data.title} date={data.event_date} />
      <SocialMediaShareBar title={data.title} />
      <BlogWysiwyg innerHtml={data.description} />
      {winSize > 600 && (
        <LayoutCenter
          id="sticky-share-socmend"
          style={{ display: "none" }}
          margin="0"
          position="sticky"
          bottom="0"
          backgroundColor="white"
          width="100%"
          widthLayout="100%"
          boxShadow
          index="0"
        >
          <LayoutCenter margin="0" justifyDesktop="flex-end">
            <p>Bagikan</p>
            <SocialMediaShareBar WidthAuto title={data.title} />
          </LayoutCenter>
        </LayoutCenter>
      )}
    </Layout>
  );
};
